/**
 * @generated SignedSource<<f58e436d5658a6c55c838251cef8f383>>
 * @relayHash a5504ccec02dffa51eb987965b73356e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b2fd6f41d7bbb1dca41273f9233e86990da12d39f841651b763fd0fe5ddc438d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type GrowthUnifiedProfileTrialTrigger = "AUTO_UPGRADE_USER_LIMIT" | "CROSSFLOW_USER_LIMIT" | "EDITION_PARITY" | "REACTIVATION" | "REVERSE_TRIAL" | "UI" | "%future added value";
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type CommerceEntitlementFilter = {
  AND?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  OR?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  inPreDunning?: boolean | null | undefined;
  inTrialOrPreDunning?: boolean | null | undefined;
};
export type editionAwarenessQuery$variables = {
  accountId: string;
  applicationKey: JiraApplicationKey;
  chargeElement: string;
  cloudId: string;
  entitlementFilter?: CommerceEntitlementFilter | null | undefined;
  onboardingStateKeys: ReadonlyArray<string>;
  productKey: string;
  shouldCheckBillingAdmin: boolean;
  shouldCheckForChargeQuantities: boolean;
  shouldCheckForDirectBuyChangeOffering: boolean;
  shouldCheckForPaymentDetails: boolean;
  shouldCheckForStorageLimit: boolean;
  shouldCheckForStorageUsageConfluence: boolean;
  shouldCheckForStorageUsageJira: boolean;
  shouldCheckForTrial: boolean;
  shouldCheckForUserEmail: boolean;
  shouldCheckUserPreferences: boolean;
  shouldIncludeProfile: boolean;
  shouldSkip: boolean;
};
export type editionAwarenessQuery$data = {
  readonly confluence_storage?: {
    readonly bytesUsed: AGG$Long;
  } | null | undefined;
  readonly jira?: {
    readonly attachmentStorageAllowed?: AGG$Long | null | undefined;
    readonly attachmentStorageIsUnlimited?: boolean | null | undefined;
    readonly attachmentStorageUsed: AGG$Long | null | undefined;
  } | null | undefined;
  readonly tenantContexts?: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement?: {
        readonly entitlementProfile?: {
          readonly lastKnownTrial: {
            readonly createdAt: number | null | undefined;
            readonly offeringId: string | null | undefined;
            readonly trialEndTimeStamp: number | null | undefined;
            readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null | undefined;
            readonly trialType: GrowthUnifiedProfileTrialType | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
          readonly changeOfferingV2WithSkipTrial?: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly latestUsageForChargeElement?: number | null | undefined;
        readonly offering?: {
          readonly key: string | null | undefined;
          readonly trial: {
            readonly lengthDays: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null | undefined;
        } | null | undefined;
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlementId: string | null | undefined;
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription?: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null | undefined;
                  readonly isAvailableToUser: boolean | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly trial: {
            readonly endTimestamp: number | null | undefined;
            readonly startTimestamp: number | null | undefined;
            readonly timeLeft: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount?: {
          readonly isBillToPresent?: boolean | null | undefined;
          readonly isCurrentUserBillingAdmin: boolean | null | undefined;
          readonly key: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly entitlementId: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly user?: {
    readonly email?: string | null | undefined;
  } | null | undefined;
  readonly userPreferences?: {
    readonly onboardingState: ReadonlyArray<{
      readonly key: string;
      readonly value: string | null | undefined;
    }>;
  } | null | undefined;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementFilter"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "onboardingStateKeys"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckBillingAdmin"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChargeQuantities"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForDirectBuyChangeOffering"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForPaymentDetails"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageLimit"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageConfluence"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageJira"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTrial"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForUserEmail"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckUserPreferences"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldIncludeProfile"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkip"
},
v19 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v20 = [
  {
    "kind": "Variable",
    "name": "applicationKey",
    "variableName": "applicationKey"
  },
  (v19/*: any*/)
],
v21 = {
  "condition": "shouldCheckForStorageUsageJira",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "shouldCheckForStorageLimit",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v20/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageAllowed"
            },
            {
              "args": (v20/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageIsUnlimited"
            }
          ]
        },
        {
          "args": (v20/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        }
      ]
    }
  ]
},
v22 = {
  "condition": "shouldCheckForStorageUsageConfluence",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        (v19/*: any*/)
      ],
      "concreteType": "ConfluenceStorage",
      "kind": "LinkedField",
      "name": "confluence_storage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "bytesUsed"
        }
      ]
    }
  ]
},
v23 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v24 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v25 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v26 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "entitlementFilter"
  }
],
v27 = {
  "kind": "ScalarField",
  "name": "id"
},
v28 = {
  "kind": "Literal",
  "name": "offeringName",
  "value": "Standard"
},
v29 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v30 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v31 = [
  (v29/*: any*/),
  (v30/*: any*/)
],
v32 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        (v28/*: any*/)
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": (v31/*: any*/),
      "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
    },
    {
      "condition": "shouldCheckForDirectBuyChangeOffering",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "changeOfferingV2WithSkipTrial",
          "args": [
            (v28/*: any*/),
            {
              "kind": "Literal",
              "name": "skipTrial",
              "value": true
            }
          ],
          "concreteType": "CcpChangeOfferingExperienceCapability",
          "kind": "LinkedField",
          "name": "changeOfferingV2",
          "plural": false,
          "selections": (v31/*: any*/),
          "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
        }
      ]
    }
  ]
},
v33 = {
  "condition": "shouldCheckForChargeQuantities",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "chargeElement",
          "variableName": "chargeElement"
        }
      ],
      "kind": "ScalarField",
      "name": "latestUsageForChargeElement"
    }
  ]
},
v34 = {
  "concreteType": "CcpEntitlementPreDunning",
  "kind": "LinkedField",
  "name": "preDunning",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v35 = {
  "concreteType": "CcpTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeLeft"
    },
    {
      "kind": "ScalarField",
      "name": "startTimestamp"
    },
    {
      "kind": "ScalarField",
      "name": "endTimestamp"
    }
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v37 = {
  "concreteType": "CcpInvoiceGroupExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
      "kind": "LinkedField",
      "name": "configurePaymentV2",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        (v29/*: any*/)
      ]
    }
  ]
},
v38 = {
  "concreteType": "CcpOfferingTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lengthDays"
    }
  ]
},
v39 = {
  "kind": "ScalarField",
  "name": "key"
},
v40 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v41 = {
  "kind": "ScalarField",
  "name": "isBillToPresent"
},
v42 = {
  "concreteType": "CcpEntitlementRelationship",
  "kind": "LinkedField",
  "name": "relatesFromEntitlements",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "relationshipType"
    },
    (v25/*: any*/)
  ]
},
v43 = {
  "condition": "shouldIncludeProfile",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
      "kind": "LinkedField",
      "name": "entitlementProfile",
      "plural": false,
      "selections": [
        {
          "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
          "kind": "LinkedField",
          "name": "lastKnownTrial",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "trialType"
            },
            {
              "kind": "ScalarField",
              "name": "trialTrigger"
            },
            {
              "kind": "ScalarField",
              "name": "trialEndTimeStamp"
            },
            {
              "kind": "ScalarField",
              "name": "createdAt"
            },
            {
              "kind": "ScalarField",
              "name": "offeringId"
            }
          ]
        }
      ]
    }
  ]
},
v44 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v45 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "email"
    }
  ],
  "type": "AtlassianAccountUser"
},
v46 = {
  "condition": "shouldCheckUserPreferences",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "UserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "key",
              "variableName": "onboardingStateKeys"
            }
          ],
          "concreteType": "UserOnboardingState",
          "kind": "LinkedField",
          "name": "onboardingState",
          "plural": true,
          "selections": [
            (v39/*: any*/),
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ]
},
v47 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      (v21/*: any*/),
      (v22/*: any*/),
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v23/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v24/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v26/*: any*/),
                        "concreteType": "CcpEntitlement",
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          {
                            "condition": "shouldCheckForTrial",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v34/*: any*/),
                              {
                                "concreteType": "CcpSubscription",
                                "kind": "LinkedField",
                                "name": "subscription",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/),
                                  {
                                    "concreteType": "CcpAccountDetails",
                                    "kind": "LinkedField",
                                    "name": "accountDetails",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "CcpInvoiceGroup",
                                        "kind": "LinkedField",
                                        "name": "invoiceGroup",
                                        "plural": false,
                                        "selections": [
                                          (v36/*: any*/),
                                          (v37/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "CcpOffering",
                                "kind": "LinkedField",
                                "name": "offering",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/),
                                  (v39/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "shouldCheckBillingAdmin",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "CcpTransactionAccount",
                                "kind": "LinkedField",
                                "name": "transactionAccount",
                                "plural": false,
                                "selections": [
                                  (v39/*: any*/),
                                  (v40/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "shouldCheckForPaymentDetails",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "CcpTransactionAccount",
                                "kind": "LinkedField",
                                "name": "transactionAccount",
                                "plural": false,
                                "selections": [
                                  (v41/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v42/*: any*/),
                          (v43/*: any*/)
                        ]
                      }
                    ],
                    "type": "CommerceEntitlementInfoCcp"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckForUserEmail",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v44/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v45/*: any*/)
            ]
          }
        ]
      },
      (v46/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v14/*: any*/),
      (v18/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v13/*: any*/),
      (v1/*: any*/),
      (v12/*: any*/),
      (v0/*: any*/),
      (v15/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v17/*: any*/),
      (v16/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      (v21/*: any*/),
      (v22/*: any*/),
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v23/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v24/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v47/*: any*/),
                  (v25/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v26/*: any*/),
                        "concreteType": "CcpEntitlement",
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          {
                            "condition": "shouldCheckForTrial",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v34/*: any*/),
                              {
                                "concreteType": "CcpSubscription",
                                "kind": "LinkedField",
                                "name": "subscription",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/),
                                  {
                                    "concreteType": "CcpAccountDetails",
                                    "kind": "LinkedField",
                                    "name": "accountDetails",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "CcpInvoiceGroup",
                                        "kind": "LinkedField",
                                        "name": "invoiceGroup",
                                        "plural": false,
                                        "selections": [
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          (v27/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v27/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "CcpOffering",
                                "kind": "LinkedField",
                                "name": "offering",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v27/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "shouldCheckBillingAdmin",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "CcpTransactionAccount",
                                "kind": "LinkedField",
                                "name": "transactionAccount",
                                "plural": false,
                                "selections": [
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v27/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "shouldCheckForPaymentDetails",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "CcpTransactionAccount",
                                "kind": "LinkedField",
                                "name": "transactionAccount",
                                "plural": false,
                                "selections": [
                                  (v41/*: any*/),
                                  (v27/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v42/*: any*/),
                          (v43/*: any*/)
                        ]
                      }
                    ],
                    "type": "CommerceEntitlementInfoCcp"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckForUserEmail",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v44/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v47/*: any*/),
              (v45/*: any*/),
              (v27/*: any*/)
            ]
          }
        ]
      },
      (v46/*: any*/)
    ]
  },
  "params": {
    "id": "b2fd6f41d7bbb1dca41273f9233e86990da12d39f841651b763fd0fe5ddc438d",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5864cd5b3ba24a1721be9fc185b7d333";

export default node;
